var map = {
	"./home.vue": [
		82609,
		609
	],
	"./privacyPolicy/en.vue": [
		50899,
		687
	],
	"./privacyPolicy/index.vue": [
		66112,
		112
	],
	"./privacyPolicy/zh.vue": [
		39568,
		568
	],
	"./termOfService/en.vue": [
		96443,
		443
	],
	"./termOfService/index.vue": [
		93389,
		389
	],
	"./termOfService/zh.vue": [
		97840,
		840
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 22385;
module.exports = webpackAsyncContext;